import { Button as MUIButton, type ButtonProps as MUIButtonProps } from "@mui/material";
import { CircularProgress } from "../CircularProgress";

export const Button = MUIButton;
export type ButtonProps = MUIButtonProps;

interface LoadingButtonProps extends ButtonProps {
  inFlight?: boolean;
}

/** @deprecated - use loading prop from button */
export const LoadingButton = ({ inFlight, disabled, startIcon, ...rest }: LoadingButtonProps) => {
  return (
    <MUIButton
      disabled={inFlight || disabled}
      startIcon={inFlight ? <CircularProgress size={20} /> : startIcon}
      {...rest}
    />
  );
};
